<template lang="pug">
  .restaurants(v-if="restaurants")
    .restaurants__border.restaurants__border--top
    .restaurants__border.restaurants__border--right
    .restaurants__border.restaurants__border--bottom
    .restaurants__border.restaurants__border--left
    .restaurants__corner.restaurants__corner--tl
    .restaurants__corner.restaurants__corner--tr
    .restaurants__corner.restaurants__corner--bl
    .restaurants__corner.restaurants__corner--br
    .restaurants__decor-top
    .restaurants__decor-bottom
    .restaurants__decor-left
    .restaurants__title(v-if="h1") {{h1}}
    .restaurants__content
      .restaurants__items(v-if="restaurants.items")
        a.restaurants__item(v-for="item in restaurants.items", :key="item.id", :href="item.link.href", target="_blank")
          .restaurants__item-left
            .restaurants__item-img-wr(v-if="item.img", :data-src="item.img")
              .restaurants__item-img-preloader
              img.restaurants__item-img(:src="item.img")
            .restaurants__item-text(v-if="item.text") {{item.text}}
          .restaurants__item-btn
            SvgIcon(name="list" width="10" height="13" class="restaurants__item-btn-ico")
            |{{item.link.title}}

</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/restaurants/restaurants.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'Restaurants',

  mixins: [AjaxHelpersVue, ImagePreloaderVue],

  data() {
    return {
      restaurants: null,
      ps: null
    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadRestaurantsPage', params => {
      this.request(params.url);
    });
  },

  methods: {
    request(url) {
      this.req('RestaurantsPage:getRestaurantsPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.restaurants = res.content;
          this.$nextTick(() => {
            this.imgPreloader('restaurants__item-img-wr', 'restaurants__item-img', 'restaurants__item-img-preloader', 250);
            this.initScroll();
          })
        }
      }, 'restaurants');
    },

    initScroll() {
      if(this.ps === null) {
        this.ps = new PerfectScrollbar('.restaurants__content', {
          wheelSpeed: 0.3,
          wheelPropagation: true,
          minScrollbarLength: 25,
          maxScrollbarLength: 25
        });
      }
      else {
        this.ps.update();
      }
    },
  }
}
</script>
